export default __webpack_public_path__ + "static/media/UG3-pvr.64294c63.jpg";